import {HomepageLane} from "@irati/types"

import laneTypes from "../../constants/laneTypes"

export default (homepageLanes: HomepageLane[], companyBenefitsTopOfHomepage: boolean) => {
  if (companyBenefitsTopOfHomepage) {
    const indexOfCompanyBenefits = homepageLanes.findIndex(({type}) => type === laneTypes.COMPANY)
    const [companyLane] = homepageLanes.splice(indexOfCompanyBenefits, 1)
    homepageLanes.unshift(companyLane)
  }
  return homepageLanes
}
